/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable no-extra-boolean-cast */

/**
 * Sample React Native App
 * https://github.com/facebook/react-native
 *
 * @format
 */
import 'react-native-gesture-handler';
import 'react-native-reanimated';
import { enableScreens } from 'react-native-screens';
import React, { useEffect, useState } from 'react';
import { setDynamicTheme, theme } from './theme/theme';
import { Provider } from 'react-redux';
import {
  ActivityIndicator,
  Button,
  PaperProvider,
  Text,
} from 'react-native-paper';
import Routes from './Routes';
import store from './store/store';
import { getInfo } from './services/Utils';
import { View } from 'react-native';
import { SafeAreaProvider } from 'react-native-safe-area-context';

enableScreens();

/**
 * Main App component that initializes theme and provides Redux + Paper provider
 * Fetches dynamic theme color from API on mount
 * @returns {React.Component} Root app component
 */
function App() {
  const [currentTheme, setCurrentTheme] = useState(false);
  const [_error, setError] = useState(null);

  /**
   * Fetches and applies dynamic theme from API
   */
  const getTheme = async () => {
    try {
      const temp = await getInfo();
      if (!!temp) {
        setDynamicTheme(temp);
        setCurrentTheme(temp?.theme_color);
      }
    } catch (error) {
      console.error(error);
      setError(error);
    }
  };

  useEffect(() => {
    getTheme();
  }, []);

  if (!currentTheme) {
    return (
      <View
        style={{
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: currentTheme || '#fff',
        }}>
        {!_error ? (
          <React.Fragment>
            <ActivityIndicator size={28} color={'#000'} />
            <Text
              variant="bodyMedium"
              style={{
                padding: 16,
                letterSpacing: 2,
                fontSize: 16,
                color: '#000',
              }}>
              Please wait loading....
            </Text>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Text
              variant="bodyMedium"
              style={{
                padding: 16,
                letterSpacing: 2,
                fontSize: 16,
                color: '#000',
              }}>
              An error occurred. Please try again later
            </Text>
            <Button mode="elevated" onPress={getTheme}>
              Retry
            </Button>
          </React.Fragment>
        )}
      </View>
    );
  }

  return (
    <SafeAreaProvider>
      <Provider store={store}>
        <PaperProvider theme={theme}>
          <Routes />
        </PaperProvider>
      </Provider>
    </SafeAreaProvider>
  );
}

export default App;
